import React from 'react';
import Header from '../components/Header';

class ProfileEdit extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="ProfileEdit" data-testid="page-profile-edit">
          <h1>ProfileEdit</h1>
        </div>
      </>
    );
  }
}

export default ProfileEdit;
